module.exports = __webpack_public_path__ + "img/epr-article-top-img@2x.bba53fe1.jpeg";